export const linkSemanticTokens = {
  text: {
    green: { value: "{colors.green.500}" },
    hover: { value: "{colors.green.800}" },
  },
  fontWeights: {
    normal: { value: "{fontWeights.normal}" },
    bold: { value: "{fontWeights.bold}" },
  },
  fontSizes: {
    xs: { value: "{fontSizes.xs}" },
    sm: { value: "{fontSizes.sm}" },
    md: { value: "{fontSizes.md}" },
    lg: { value: "{fontSizes.lg}" },
  },
};
